import { makeCancellableAPIRequest } from "restAPI"

export const SuperAdminAPI = {
    getAllTenants(data){
        return makeCancellableAPIRequest(
            "POST",
            "/api/super-admin/stats",
            {
                data
            }
        )
    },
    getAllTenantsFilter(data) {
        return makeCancellableAPIRequest(
            "POST",
            "/api/super-admin/stats-filter",
            {
                data
            }
        )
    },
    getAllTenants2(){
        return makeCancellableAPIRequest(
            "GET",
            "/organisation"
        )
    },
    createTenant(data){
        return makeCancellableAPIRequest(
            "POST",
            "/organisation",
            {
                data
            }
        )
    },

    getFeatureFlags(){
        return makeCancellableAPIRequest(
            "GET",
            "/api/super-admin/feature-flag"
        )
    },
    createFeatureFlag(data){
        return makeCancellableAPIRequest(
            "POST",
            "/api/super-admin/feature-flag",
            {
                data
            }
        )
    },
    editFeatureFlag(data){
        return makeCancellableAPIRequest(
            "PUT",
            "/api/super-admin/feature-flag",
            {
                data
            }
        )
    },
    deleteFeatureFlag(data){
        return makeCancellableAPIRequest(
            "DELETE",
            "/api/super-admin/feature-flag",
            {
                data
            }
        )
    },
    updateLicenceTracking(data) {
        return makeCancellableAPIRequest(
            "PUT",
            "/api/super-admin/license-tracking",
            {
                data
            }
        )
    },
    getTrialModule(id) {
        return makeCancellableAPIRequest(
            "GET",
            `/organisation/${id}/entitlements`
        )
    },
}